import { memo } from 'react'

import { useHostNavigateToPath } from './useHostNavigateToPath'

export const HostRouteObserver = memo(() => {
  const renderConfirm = useHostNavigateToPath()

  return <>{renderConfirm?.()}</>
})
HostRouteObserver.displayName = 'HostRouteObserver'
